import { computed, inject, Injectable, resource } from '@angular/core';

import { MaintenancePeriodGateway } from './maintenance-period.gateway';

/**
 * The scheduled maintenance announced on the dashboard, loaded once on first use.
 * The state lives as long as the page: logging out leaves the application, so there is no session reset.
 */
@Injectable({ providedIn: 'root' })
export class MaintenancePeriodStore {
    private readonly gateway = inject(MaintenancePeriodGateway);
    private readonly period = resource({ loader: () => this.gateway.getCurrent() });

    /** Null while loading, when nothing is scheduled, or when the request failed. */
    readonly current = computed(() => (this.period.hasValue() ? this.period.value() : null));
}
